import React, { useState, useEffect } from 'react';

const LoginAdmin = ({ 
    onBack, 
    Icons,
    apiBase
}) => {
    // --- Auth State ---
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    // --- News State ---
    const [news, setNews] = useState([]);
    const [newTitle, setNewTitle] = useState('');
    const [newText, setNewText] = useState('');
    const [isNewsSubmitting, setIsNewsSubmitting] = useState(false);

    // --- Comments State ---
    const [allComments, setAllComments] = useState([]);
    const [activeTab, setActiveTab] = useState('pending'); // 'pending' or 'approved'
    const [isLoadingComments, setIsLoadingComments] = useState(false);

    // --- Handbooks State ---
    const [courses, setCourses] = useState([]);
    const [newCourseTitle, setNewCourseTitle] = useState('');
    const [newCourseDesc, setNewCourseDesc] = useState('');
    const [newLinkTitle, setNewLinkTitle] = useState('');
    const [newLinkUrl, setNewLinkUrl] = useState('');
    const [selectedCourseId, setSelectedCourseId] = useState('');

    // --- Edit Handbooks State ---
    const [editingCourseId, setEditingCourseId] = useState(null);
    const [editCourseTitle, setEditCourseTitle] = useState('');
    const [editCourseDesc, setEditCourseDesc] = useState('');

    const [editingLinkId, setEditingLinkId] = useState(null);
    const [editLinkTitle, setEditLinkTitle] = useState('');
    const [editLinkUrl, setEditLinkUrl] = useState('');

    // --- Effects ---
    useEffect(() => {
        if (isAuthenticated && apiBase) {
            fetchNews();
            fetchComments();
            fetchCourses();
        }
    }, [isAuthenticated, apiBase]);

    // --- Auth Logic ---
    const handleLogin = (e) => {
        e.preventDefault();
        // ورود مدیریت به صورت هاردکد (همانند قبل) باقی می‌ماند
        if (username === 'admin1997' && password === '@Kia13761376') {
            setIsAuthenticated(true);
        } else {
            alert('نام کاربری یا رمز عبور اشتباه است.');
        }
    };

    // --- News Actions ---
    const fetchNews = async () => {
        try {
            const response = await fetch(`${apiBase}/news.php`);
            const data = await response.json();
            if (Array.isArray(data)) setNews(data);
        } catch (error) {
            console.error(error);
        }
    };

    const handleAddNewsSubmit = async (e) => {
        e.preventDefault();
        if (!newTitle.trim() || !newText.trim()) return;
        
        setIsNewsSubmitting(true);
        try {
            const response = await fetch(`${apiBase}/news.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ title: newTitle, text: newText, author: 'مدیریت' })
            });
            const result = await response.json();

            if (result.success) {
                // خبر جدید را به لیست اضافه کن (یک آبجکت موقت بساز تا نیاز به رفرش نباشد)
                const newNewsItem = { 
                    id: result.id, 
                    title: newTitle, 
                    text: newText, 
                    created_at: new Date().toISOString() 
                };
                setNews([newNewsItem, ...news]);
                setNewTitle('');
                setNewText('');
                alert('خبر با موفقیت ثبت شد.');
            } else {
                throw new Error('خطا در ثبت');
            }
        } catch (error) {
            alert('خطا در ثبت خبر.');
            console.error(error);
        } finally {
            setIsNewsSubmitting(false);
        }
    };

    const handleDeleteNews = async (id) => {
        if (!window.confirm('آیا از حذف این خبر مطمئن هستید؟')) return;

        try {
            const response = await fetch(`${apiBase}/news.php`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: id })
            });
            const result = await response.json();

            if (result.success) {
                setNews(news.filter(item => item.id !== id));
            } else {
                alert('خطا در حذف خبر.');
            }
        } catch (error) {
            console.error(error);
        }
    };

    // --- Comments Actions ---
    const fetchComments = async () => {
        setIsLoadingComments(true);
        try {
            // دریافت هر دو دسته نظرات و ادغام آن‌ها (چون در API جداگانه هستند، اینجا دو بار فچ می‌کنیم یا همه را می‌گیریم)
            // راه حل ساده: دو درخواست بزنیم و ترکیب کنیم
            const [res1, res2] = await Promise.all([
                fetch(`${apiBase}/comments.php?approved=0`),
                fetch(`${apiBase}/comments.php?approved=1`)
            ]);
            
            const pending = await res1.json();
            const approved = await res2.json();
            
            setAllComments([...pending, ...approved]);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadingComments(false);
        }
    };

    const handleVerifyComment = async (id) => {
        try {
            const response = await fetch(`${apiBase}/comments.php`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: id })
            });
            const result = await response.json();

            if (result.success) {
                setAllComments(allComments.map(c => c.id === id ? { ...c, is_approved: 1 } : c));
            } else {
                alert('خطا در تایید نظر');
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleDeleteComment = async (id) => {
        if (!window.confirm('آیا از حذف این نظر مطمئن هستید؟')) return;
        
        try {
            const response = await fetch(`${apiBase}/comments.php`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: id })
            });
            const result = await response.json();

            if (result.success) {
                setAllComments(allComments.filter(c => c.id !== id));
            } else {
                alert('خطا در حذف نظر');
            }
        } catch (error) {
            console.error(error);
        }
    };

    // فیلتر کردن نظرات برای نمایش در تب‌ها
    const filteredComments = allComments.filter(c => activeTab === 'approved' ? c.is_approved == 1 : c.is_approved == 0);

    // --- Handbooks Actions ---
    const fetchCourses = async () => {
        try {
            const response = await fetch(`${apiBase}/handbooks.php`);
            const data = await response.json();
            if (Array.isArray(data)) {
                setCourses(data);
                if(data.length > 0) setSelectedCourseId(data[0].id);
            }
        } catch (error) { console.error(error); }
    };

    const handleAddCourse = async (e) => {
        e.preventDefault();
        if (!newCourseTitle.trim()) return;
        try {
            const response = await fetch(`${apiBase}/handbooks.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'add_course', title: newCourseTitle, description: newCourseDesc })
            });
            const result = await response.json();
            if (result.success) {
                alert('درس جدید اضافه شد.');
                setNewCourseTitle(''); setNewCourseDesc('');
                fetchCourses(); // آپدیت لیست
            }
        } catch (error) { console.error(error); }
    };

    const handleAddLink = async (e) => {
        e.preventDefault();
        if (!newLinkTitle.trim() || !newLinkUrl.trim() || !selectedCourseId) return;
        try {
            const response = await fetch(`${apiBase}/handbooks.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'add_link', course_id: selectedCourseId, title: newLinkTitle, url: newLinkUrl })
            });
            const result = await response.json();
            if (result.success) {
                alert('لینک جزوه با موفقیت اضافه شد.');
                setNewLinkTitle(''); setNewLinkUrl('');
                fetchCourses(); 
            }
        } catch (error) { console.error(error); }
    };

    const handleDeleteCourse = async (id) => {
        if (!window.confirm('با حذف درس، تمام جزوات آن نیز حذف می‌شوند. مطمئن هستید؟')) return;
        try {
            const response = await fetch(`${apiBase}/handbooks.php`, {
                method: 'DELETE', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'delete_course', id })
            });
            const result = await response.json();
            if (result.success) fetchCourses();
        } catch (error) { console.error(error); }
    };

    const handleDeleteLink = async (id) => {
        if (!window.confirm('حذف لینک جزوه انجام شود؟')) return;
        try {
            const response = await fetch(`${apiBase}/handbooks.php`, {
                method: 'DELETE', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'delete_link', id })
            });
            const result = await response.json();
            if (result.success) fetchCourses();
        } catch (error) { console.error(error); }
    };

    const handleEditCourse = async (e, id) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiBase}/handbooks.php`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'edit_course', id, title: editCourseTitle, description: editCourseDesc })
            });
            const result = await response.json();
            if (result.success) {
                alert('درس با موفقیت ویرایش شد.');
                setEditingCourseId(null);
                fetchCourses();
            }
        } catch (error) { console.error(error); }
    };

    const handleEditLink = async (e, id) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiBase}/handbooks.php`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'edit_link', id, title: editLinkTitle, url: editLinkUrl })
            });
            const result = await response.json();
            if (result.success) {
                alert('لینک با موفقیت ویرایش شد.');
                setEditingLinkId(null);
                fetchCourses();
            }
        } catch (error) { console.error(error); }
    };

    // --- Render Login ---
    if (!isAuthenticated) {
        return (
            <div className="login-admin-body-override">
                {/* استایل‌های قبلی لاگین ادمین بدون تغییر */}
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@400;700&display=swap');
                    .login-admin-body-override { width: 100vw; height: 100vh; background: #081b29; display: flex; justify-content: center; align-items: center; position: fixed; top: 0; left: 0; z-index: 9999; font-family: 'Arial', sans-serif; direction: ltr; }
                    .login-admin-body-override * { margin: 0; padding: 0; box-sizing: border-box; }
                    .wrapper { position: relative; width: 800px; height: 500px; display: flex; background: #081b29; border: 3px solid #00ffff; box-shadow: 0 0 50px 0 #00a6bc; border-radius: 20px; overflow: hidden; direction: ltr; }
                    .form-container { width: 50%; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px; z-index: 10; }
                    .title { font-size: 35px; color: #fff; margin-bottom: 30px; font-weight: bold; }
                    .inp { width: 100%; margin-bottom: 25px; position: relative; }
                    .input { width: 100%; background: transparent; border: none; border-bottom: 2px solid #eee; padding: 10px 0; padding-right: 30px; font-size: 16px; color: #fff; outline: none; transition: 0.3s; }
                    .input:focus { border-bottom: 2px solid #0ef; }
                    .input::placeholder { color: #ccc; }
                    .toggle-password { position: absolute; right: 0; top: 10px; background: none; border: none; color: #ccc; cursor: pointer; display: flex; align-items: center; transition: 0.3s; }
                    .toggle-password:hover { color: #0ef; }
                    .submit { width: 100%; height: 45px; background: linear-gradient(45deg, #0ef, #c800ff); border: none; outline: none; border-radius: 40px; cursor: pointer; font-size: 18px; color: #fff; font-weight: bold; margin-top: 10px; transition: 0.3s; box-shadow: 0 0 10px rgba(0, 239, 255, 0.5); }
                    .submit:hover { box-shadow: 0 0 20px rgba(0, 239, 255, 0.8); }
                    .banner { position: absolute; top: 0; right: 0; width: 55%; height: 100%; background: linear-gradient(to right, #0ef, #c800ff); clip-path: polygon(20% 0, 100% 0, 100% 100%, 0% 100%); display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding-left: 60px; padding-right: 20px; }
                    .wel_text { font-family: 'Vazirmatn', sans-serif; font-size: 32px; color: #fff; line-height: 1.5; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.2); direction: rtl; }
                    .back-btn-container { position: absolute; top: 20px; left: 20px; z-index: 20; }
                    .back-btn { background: none; border: none; color: #0ef; cursor: pointer; display: flex; align-items: center; gap: 8px; font-size: 14px; transition: 0.3s; padding: 8px 12px; border-radius: 20px; border: 1px solid transparent; }
                    .back-btn:hover { color: #fff; border: 1px solid #0ef; background: rgba(0, 239, 255, 0.1); }
                `}</style>

                <div className="wrapper">
                    <div className="back-btn-container">
                        <button onClick={onBack} className="back-btn" title="بازگشت به سایت">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                <polyline points="9 22 9 12 15 12 15 22"></polyline>
                            </svg>
                            <span>Home</span>
                        </button>
                    </div>

                    <form className="form-container" onSubmit={handleLogin}>
                        <h1 className="title">Login</h1>
                        <div className="inp">
                            <input 
                                className="input" 
                                type="text" 
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </div>
                        <div className="inp">
                            <input 
                                className="input" 
                                type={showPassword ? "text" : "password"} 
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button 
                                type="button"
                                className="toggle-password"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                                        <line x1="1" y1="1" x2="23" y2="23"></line>
                                    </svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                        <circle cx="12" cy="12" r="3"></circle>
                                    </svg>
                                )}
                            </button>
                        </div>
                        <button className="submit">Log In</button>
                    </form>
                    
                    <div className="banner">
                        <div className="wel_text">
                            به پنل مدیریت<br/>
                            سایت دانش سازه<br/>
                            خوش آمدید
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // --- Render Dashboard ---
    return (
        <div className="fixed inset-0 z-[60] overflow-y-auto bg-[#f0f0f3] p-6 animate-fadeIn dir-rtl font-vazir text-slate-700">
            <style>{`
                .glass-card {
                    border-radius: 30px;
                    background: linear-gradient(145deg, #e6d8d8, #ffffff);
                    box-shadow: 17px 17px 34px #b8adad, -17px -17px 34px #ffffff;
                    border: none;
                }
                .shadow-neu { box-shadow: 17px 17px 34px #b8adad, -17px -17px 34px #ffffff; }
                .shadow-neu-inset { box-shadow: inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff; }
                .btn-deep { box-shadow: 6px 6px 12px #b8adad, -6px -6px 12px #ffffff; transition: all 0.3s ease; }
                .btn-deep:hover { box-shadow: 10px 10px 20px #b8adad, -10px -10px 20px #ffffff; transform: translateY(-3px); }
                .btn-deep:active { box-shadow: inset 5px 5px 10px #bebebe, inset -5px -5px 10px #ffffff; transform: translateY(0); }
                .custom-scrollbar::-webkit-scrollbar { width: 6px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
            `}</style>
            
            <div className="container mx-auto max-w-6xl">
                {/* Header */}
                <div className="flex justify-between items-center mb-10">
                    <h1 className="text-3xl font-bold text-slate-800">پنل مدیریت محتوا</h1>
                    <button onClick={onBack} className="bg-[#f0f0f3] btn-deep px-4 py-2 rounded-xl text-red-500 flex items-center gap-2 transition-all">
                        <Icons.LogOut size={18} />
                        خروج و بازگشت
                    </button>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
                    {/* Add News Form */}
                    <div className="glass-card p-6 h-fit">
                        <h3 className="text-xl font-bold text-slate-700 mb-6 flex items-center gap-2">
                            <Icons.Edit size={20} className="text-blue-600" />
                            افزودن خبر جدید
                        </h3>
                        <form onSubmit={handleAddNewsSubmit} className="space-y-4">
                            <div>
                                <label className="block text-xs font-bold text-slate-500 mb-2">عنوان خبر</label>
                                <input 
                                    required
                                    type="text"
                                    value={newTitle}
                                    onChange={(e) => setNewTitle(e.target.value)}
                                    className="w-full bg-[#f0f0f3] shadow-neu-inset rounded-xl px-4 py-2 outline-none text-slate-700"
                                />
                            </div>
                            <div>
                                <label className="block text-xs font-bold text-slate-500 mb-2">متن کامل</label>
                                <textarea 
                                    required
                                    rows="6"
                                    value={newText}
                                    onChange={(e) => setNewText(e.target.value)}
                                    className="w-full bg-[#f0f0f3] shadow-neu-inset rounded-xl px-4 py-3 outline-none text-slate-700 resize-none custom-scrollbar"
                                    placeholder="متن خبر را اینجا بنویسید..."
                                ></textarea>
                            </div>
                            <button 
                                disabled={isNewsSubmitting}
                                type="submit" 
                                className="w-full bg-[#f0f0f3] btn-deep text-green-600 font-bold py-3 rounded-xl transition-all disabled:opacity-50"
                            >
                                {isNewsSubmitting ? 'در حال ارسال...' : 'انتشار خبر'}
                            </button>
                        </form>
                    </div>

                    {/* News List */}
                    <div className="glass-card p-6 h-full min-h-[500px]">
                        <h3 className="text-xl font-bold text-slate-700 mb-6 flex items-center gap-2">
                            <Icons.List size={20} className="text-blue-600" />
                            لیست اخبار ({news.length})
                        </h3>
                        <div className="space-y-4 max-h-[500px] overflow-y-auto custom-scrollbar p-2">
                            {news.map(item => (
                                <div key={item.id} className="bg-[#f0f0f3] shadow-neu rounded-xl p-4 flex justify-between items-start group">
                                    <div className="flex-1 ml-4">
                                        <h4 className="font-bold text-slate-800 text-sm">{item.title}</h4>
                                        <p className="text-xs text-slate-500 mt-1 truncate opacity-70">
                                            {item.text ? item.text.substring(0, 50) + '...' : ''}
                                        </p>
                                        <span className="text-[10px] text-blue-500 mt-2 block">
                                            {new Date(item.created_at).toLocaleDateString('fa-IR')}
                                        </span>
                                    </div>
                                    <button 
                                        onClick={() => handleDeleteNews(item.id)}
                                        className="text-red-400 hover:text-red-600 p-2 rounded-lg hover:bg-red-50 transition-colors"
                                        title="حذف خبر"
                                    >
                                        <Icons.Trash2 size={18} />
                                    </button>
                                </div>
                            ))}
                            {news.length === 0 && (
                                <p className="text-center text-slate-400 text-sm mt-10">هیچ خبری یافت نشد.</p>
                            )}
                        </div>
                    </div>
                </div>

                {/* ---------------- بخش مدیریت جزوات و دروس ---------------- */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
                    {/* فرم افزودن درس و لینک */}
                    <div className="glass-card p-6 h-fit space-y-8">
                        {/* افزودن درس جدید */}
                        <div>
                            <h3 className="text-xl font-bold text-slate-700 mb-4 flex items-center gap-2">
                                <Icons.List size={20} className="text-blue-600" />
                                افزودن درس / سرفصل جدید
                            </h3>
                            <form onSubmit={handleAddCourse} className="space-y-4">
                                <input required type="text" value={newCourseTitle} onChange={(e) => setNewCourseTitle(e.target.value)} placeholder="عنوان درس (مثلا تحلیل سازه 1)" className="w-full bg-[#f0f0f3] shadow-neu-inset rounded-xl px-4 py-2 outline-none text-slate-700" />
                                <textarea rows="2" value={newCourseDesc} onChange={(e) => setNewCourseDesc(e.target.value)} placeholder="توضیحات (اختیاری)" className="w-full bg-[#f0f0f3] shadow-neu-inset rounded-xl px-4 py-2 outline-none text-slate-700 resize-none custom-scrollbar"></textarea>
                                <button type="submit" className="w-full bg-[#f0f0f3] btn-deep text-blue-600 font-bold py-2 rounded-xl">ثبت درس جدید</button>
                            </form>
                        </div>
                        <hr className="border-slate-300" />
                        {/* افزودن لینک جزوه */}
                        <div>
                            <h3 className="text-xl font-bold text-slate-700 mb-4 flex items-center gap-2">
                                <Icons.Download size={20} className="text-green-600" />
                                افزودن فایل / لینک جزوه
                            </h3>
                            <form onSubmit={handleAddLink} className="space-y-4">
                                <select value={selectedCourseId} onChange={(e) => setSelectedCourseId(e.target.value)} className="w-full bg-[#f0f0f3] shadow-neu-inset rounded-xl px-4 py-2 outline-none text-slate-700">
                                    <option value="">انتخاب درس...</option>
                                    {courses.map(c => <option key={c.id} value={c.id}>{c.title}</option>)}
                                </select>
                                <input required type="text" value={newLinkTitle} onChange={(e) => setNewLinkTitle(e.target.value)} placeholder="عنوان فایل (مثلا جلسه اول)" className="w-full bg-[#f0f0f3] shadow-neu-inset rounded-xl px-4 py-2 outline-none text-slate-700" />
                                <input required type="url" value={newLinkUrl} onChange={(e) => setNewLinkUrl(e.target.value)} placeholder="لینک دانلود فایل (http://...)" className="w-full bg-[#f0f0f3] shadow-neu-inset rounded-xl px-4 py-2 outline-none text-slate-700" style={{direction: 'ltr'}} />
                                <button type="submit" className="w-full bg-[#f0f0f3] btn-deep text-green-600 font-bold py-2 rounded-xl">افزودن لینک به درس</button>
                            </form>
                        </div>
                    </div>

                    {/* لیست دروس و جزوات موجود */}
                    <div className="glass-card p-6 h-full min-h-[500px]">
                        <h3 className="text-xl font-bold text-slate-700 mb-6 flex items-center gap-2">
                            <Icons.List size={20} className="text-blue-600" />
                            دروس و جزوات ثبت شده
                        </h3>
                        <div className="space-y-4 max-h-[600px] overflow-y-auto custom-scrollbar p-2">
                            {courses.map(course => (
                                <div key={course.id} className="bg-[#f0f0f3] shadow-neu rounded-xl p-4 mb-4">
                                    {/* بخش ویرایش یا نمایش عنوان درس */}
                                    {editingCourseId === course.id ? (
                                        <form onSubmit={(e) => handleEditCourse(e, course.id)} className="mb-3 space-y-2">
                                            <input required type="text" value={editCourseTitle} onChange={(e) => setEditCourseTitle(e.target.value)} className="w-full bg-white rounded-lg px-3 py-2 text-sm border shadow-sm outline-none" placeholder="عنوان درس" />
                                            <textarea value={editCourseDesc} onChange={(e) => setEditCourseDesc(e.target.value)} className="w-full bg-white rounded-lg px-3 py-2 text-sm border shadow-sm outline-none resize-none" placeholder="توضیحات دسته‌بندی"></textarea>
                                            <div className="flex gap-2">
                                                <button type="submit" className="text-xs bg-green-500 hover:bg-green-600 text-white px-3 py-1.5 rounded-lg transition-colors">ذخیره تغییرات</button>
                                                <button type="button" onClick={() => setEditingCourseId(null)} className="text-xs bg-slate-400 hover:bg-slate-500 text-white px-3 py-1.5 rounded-lg transition-colors">انصراف</button>
                                            </div>
                                        </form>
                                    ) : (
                                        <div className="flex justify-between items-center mb-3">
                                            <h4 className="font-bold text-slate-800">{course.title}</h4>
                                            <div className="flex gap-1">
                                                <button onClick={() => { setEditingCourseId(course.id); setEditCourseTitle(course.title); setEditCourseDesc(course.description || ''); }} className="text-blue-400 hover:text-blue-600 bg-blue-50 p-1.5 rounded-lg transition-colors" title="ویرایش دسته‌بندی">
                                                    <Icons.Edit size={16} />
                                                </button>
                                                <button onClick={() => handleDeleteCourse(course.id)} className="text-red-400 hover:text-red-600 bg-red-50 p-1.5 rounded-lg transition-colors" title="حذف کامل درس">
                                                    <Icons.Trash2 size={16} />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {/* بخش فایل‌ها و لینک‌های زیرمجموعه */}
                                    <ul className="space-y-2 mt-2 bg-slate-100/50 rounded-lg p-3">
                                        {course.links && course.links.map(link => (
                                            <li key={link.id} className="text-sm border-b border-slate-200/60 pb-2 last:border-0 last:pb-0">
                                                {editingLinkId === link.id ? (
                                                    <form onSubmit={(e) => handleEditLink(e, link.id)} className="flex flex-col gap-2 w-full mt-1">
                                                        <input required type="text" value={editLinkTitle} onChange={(e) => setEditLinkTitle(e.target.value)} className="w-full bg-white rounded-md px-2 py-1.5 text-xs border outline-none" placeholder="عنوان فایل" />
                                                        <input required type="url" value={editLinkUrl} onChange={(e) => setEditLinkUrl(e.target.value)} className="w-full bg-white rounded-md px-2 py-1.5 text-xs border outline-none text-left" dir="ltr" placeholder="لینک فایل" />
                                                        <div className="flex gap-2">
                                                            <button type="submit" className="text-[11px] bg-green-500 text-white px-2 py-1 rounded">ذخیره</button>
                                                            <button type="button" onClick={() => setEditingLinkId(null)} className="text-[11px] bg-slate-400 text-white px-2 py-1 rounded">انصراف</button>
                                                        </div>
                                                    </form>
                                                ) : (
                                                    <div className="flex justify-between items-center">
                                                        <span className="text-slate-600 truncate max-w-[200px]" title={link.title}>{link.title}</span>
                                                        <div className="flex gap-2">
                                                            <button onClick={() => { setEditingLinkId(link.id); setEditLinkTitle(link.title); setEditLinkUrl(link.url); }} className="text-blue-500 hover:text-blue-700 font-bold text-xs" title="ویرایش لینک">ویرایش</button>
                                                            <button onClick={() => handleDeleteLink(link.id)} className="text-red-500 hover:text-red-700 font-bold text-xs" title="حذف لینک">حذف</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </li>
                                        ))}
                                        {(!course.links || course.links.length === 0) && <li className="text-xs text-slate-400">فایلی آپلود نشده است.</li>}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* ---------------- پایان بخش جزوات ---------------- */}

                {/* Comments Section */}
                <div className="glass-card p-6 w-full mb-8">
                    <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                        <h3 className="text-xl font-bold text-slate-700 flex items-center gap-2">
                            <Icons.User size={20} className="text-blue-600" />
                            مدیریت نظرات
                        </h3>
                        <div className="flex bg-[#f0f0f3] shadow-neu-inset rounded-xl p-1">
                            <button 
                                onClick={() => setActiveTab('pending')}
                                className={`px-4 py-2 rounded-lg text-sm font-bold transition-all ${activeTab === 'pending' ? 'bg-[#f0f0f3] shadow-neu text-blue-600' : 'text-slate-400'}`}
                            >
                                در انتظار تایید ({allComments.filter(c => c.is_approved == 0).length})
                            </button>
                            <button 
                                onClick={() => setActiveTab('approved')}
                                className={`px-4 py-2 rounded-lg text-sm font-bold transition-all ${activeTab === 'approved' ? 'bg-[#f0f0f3] shadow-neu text-green-600' : 'text-slate-400'}`}
                            >
                                تایید شده ({allComments.filter(c => c.is_approved == 1).length})
                            </button>
                        </div>
                    </div>

                    <div className="space-y-4 max-h-[400px] overflow-y-auto custom-scrollbar p-2">
                        {isLoadingComments ? (
                            <p className="text-center text-slate-400">در حال بارگذاری نظرات...</p>
                        ) : filteredComments.length === 0 ? (
                            <p className="text-center text-slate-400 text-sm py-8">هیچ نظری در این بخش وجود ندارد.</p>
                        ) : (
                            filteredComments.map(comment => (
                                <div key={comment.id} className="bg-[#f0f0f3] shadow-neu rounded-xl p-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                                    <div className="flex-1">
                                        <div className="flex items-center gap-2 mb-1">
                                            <span className="font-bold text-slate-800 text-sm">{comment.name || 'کاربر مهمان'}</span>
                                            <span className="text-[10px] text-slate-400 bg-slate-200 px-2 py-0.5 rounded-full">
                                                {new Date(comment.created_at).toLocaleDateString('fa-IR')}
                                            </span>
                                        </div>
                                        <p className="text-sm text-slate-600 leading-relaxed">{comment.text}</p>
                                    </div>
                                    <div className="flex items-center gap-2 w-full md:w-auto justify-end">
                                        {comment.is_approved == 0 && (
                                            <button 
                                                onClick={() => handleVerifyComment(comment.id)}
                                                className="bg-[#f0f0f3] shadow-neu hover:shadow-neu-inset text-green-600 p-2 rounded-lg transition-all"
                                                title="تایید نظر"
                                            >
                                                <Icons.Check size={18} />
                                            </button>
                                        )}
                                        <button 
                                            onClick={() => handleDeleteComment(comment.id)}
                                            className="bg-[#f0f0f3] shadow-neu hover:shadow-neu-inset text-red-500 p-2 rounded-lg transition-all"
                                            title="حذف نظر"
                                        >
                                            <Icons.Trash2 size={18} />
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginAdmin;